<div class="search-bar-container">
    <div class="search-bar-form">
        <form [formGroup]="searchPureOriginalForm">
            <span><i class="bi bi-search"></i></span>
            <input formControlName="searchString" type="text" placeholder="Search pure originals / masters"/>
        </form>
    </div>

    <div class="list-of-pure-originals" [ngClass]="pureOriginalService.globalSearchByWinOls().length > 0 ? 'show-list' : ''">
        <div class="search-title">
            <span>Top 5 Results</span>
        </div>
        <div class="list-of-pure-originals-wrapper">
            <li *ngFor="let element of pureOriginalService.globalSearchByWinOls()" (click)="openDetailsBasedOnTable(element)">
                <div class="search-result-line">
   <span class="references">
  {{ element.winOlsReference }}
       <ng-container *ngIf="element.masterWinOlsReference && element.versionName">
     {{ element.masterWinOlsReference }} / {{ element.versionName }}
  </ng-container>
</span><span class="table-name-muted">{{ element.tableName }}</span>
                </div>
            </li>
        </div>
    </div>


